// extracted by mini-css-extract-plugin
export var container = "_9o-0";
export var error = "_9o-9";
export var label = "_9o-5";
export var light = "_9o-6";
export var md = "_9o-3";
export var sm = "_9o-2";
export var thin = "_9o-8";
export var thinBold = "_9o-7";
export var vertical = "_9o-4";
export var xs = "_9o-1";